


























import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { ICaseRecordTypeInput } from '@/modules/Case/interfaces/case-form'

@Component({
  components: {
    AppTextSearch
  }
})
export default class CaseFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => ICaseRecordTypeInput }) value!: ICaseRecordTypeInput
  @Prop({ type: Boolean }) disabled!: boolean

  mounted () {
    this.getRecordTypes(RecordTypeMaster.POLICY)
  }

  recentlyClickHandler (index: number) {
    const recordType = this.recentlyUsedRecordTypes[index]
    this.candidateRecordTypes.push()
    const findIndex = this.candidateRecordTypes.findIndex(rt => rt.name === recordType.name)
    if (findIndex === -1) {
      this.candidateRecordTypes = [...this.candidateRecordTypes, recordType]
    }
    this.value.recordType = {
      name: recordType.name,
      id: +recordType.id
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
